{
  "account": {
    "id": "ID",
    "stringId": "ID chaîne",
    "custodianAccountNumber": "Numéro dépositaire",
    "custodianAccountName": "Nom du dépositaire",
    "type": "Type",
    "translatedAccountType": "Type traduit",
    "state": "État",
    "lastUpdatedBy": "Dernière mise à jour par",
    "applyForGovFunds": "Demande de fonds gouvernementaux",
    "sourceOfFunds": "Source des fonds",
    "tlhEnabled": "Récupération fiscale activée",
    "forceOpen": "Ouverture forcée",
    "jurisdiction": "Juridiction",
    "feePaymentAccount": "Compte de paiement des frais",
    "taxRank": "Rang fiscal",
    "defaultTaxRank": "Rang fiscal par défaut",
    "requiresFeeRedirectionSigned": "Redirection des frais signée requise",
    "feeRedirectionSignedAt": "Redirection des frais signée le",
    "overrideTaxRank": "Rang fiscal de remplacement",
    "baseCurrency": "Devise de base",
    "availableCurrencies": "Devises disponibles",
    "translatedNickName": "Surnom traduit",
    "custodianSortingOrderPriority": "Priorité d'ordre de tri du dépositaire",
    "createdAt": "Créé le",
    "updatedAt": "Mis à jour le",
    "activatedAt": "Activé le",
    "dealerCode": "Code du courtier",
    "dealerName": "Nom du courtier",
    "dealerAccountNumber": "Numéro de compte du courtier",
    "groupEmployer": "Employeur du groupe",
    "groupNumber": "Numéro de groupe",
    "sourceType": "Type de source",
    "externalSourceType": "Type de source externe",
    "eligibleForDisabilityTaxCredit": "Admissible au crédit d'impôt pour invalidité",
    "rightOfSurvivorship": "Droit de survie",
    "respAllBeneficiariesAreInBc": "REEE tous les bénéficiaires en C.-B.",
    "user": "Utilisateur",
    "organization": "Organisation",
    "householdClientGroup": "Ménage",
    "repCode": "Code du représentant",
    "transactionsTotal": "Total des transactions",
    "program": "Programme",
    "feeTier": "Palier de frais",
    "applicableFeeTier": "Palier de frais applicable",
    "billingSchedule": "Calendrier de facturation",
    "applicableBillingSchedule": "Calendrier de facturation applicable",
    "statistics": "Statistiques",
    "scheduledIncomeFundTransfer": "Transfert de fonds de revenu planifié",
    "custodianConnection": "Connexion dépositaire"
  },
  "subAccount": {
    "id": "ID",
    "name": "Nom",
    "state": "État",
    "suitabilityScore": "Score d'adéquation",
    "calculatedSuitabilityScore": "Score d'adéquation calculé",
    "createdAt": "Créé le",
    "signedAllFormsAt": "Formulaires signés le",
    "completedAt": "Complété le",
    "incompleteFields": "Champs incomplets",
    "approvedAt": "Approuvé le",
    "lastUpdatedBy": "Dernière mise à jour par",
    "skipIPS": "Ignorer le PPI",
    "allowClientDeposits": "Autoriser les dépôts client",
    "isPartial": "Partiel",
    "liquidated": "Liquidé",
    "tradingProcess": "Processus de négociation",
    "baseCurrency": "Devise de base",
    "sourceType": "Type de source",
    "custodianSuitabilityScore": "Score d'adéquation du dépositaire",
    "financialProductId": "ID produit financier du sous-compte",
    "acceptableFinancialProduct": "Produit financier acceptable",
    "account": "Compte",
    "goal": "Objectif",
    "organization": "Organisation",
    "theme": "Thème",
    "schedule": "Calendrier",
    "financialProduct": "Produit financier",
    "feeTier": "Palier de frais",
    "applicableFeeTier": "Palier de frais applicable",
    "billingSchedule": "Calendrier de facturation",
    "applicableBillingSchedule": "Calendrier de facturation applicable",
    "suggestedFinancialProduct": "Produit financier suggéré",
    "statistics": "Statistiques"
  },
  "goal": {
    "id": "ID",
    "name": "Nom",
    "type": "Type",
    "timeHorizon": "Horizon temporel",
    "expectedAnnualIncomeCents": "Revenu annuel attendu (cents)",
    "targetAmountCents": "Montant cible (cents)",
    "retirementAge": "Âge de la retraite",
    "targetDate": "Date cible",
    "riskQuestion1": "Question de risque 1",
    "suitabilityScore": "Score d'adéquation",
    "state": "État",
    "calculatedSuitabilityScore": "Score d'adéquation calculé",
    "lastUpdatedBy": "Dernière mise à jour par",
    "taxOptimized": "Optimisé fiscalement",
    "pendingAgreementSignature": "Signature d'entente en attente",
    "tradingProcess": "Processus de négociation",
    "timeHorizonLabel": "Libellé de l'horizon temporel",
    "goalRiskQuestionLabel": "Libellé de la question de risque",
    "createdAt": "Créé le",
    "user": "Utilisateur",
    "householdClientGroup": "Ménage",
    "organization": "Organisation",
    "financialProduct": "Produit financier",
    "suggestedFinancialProduct": "Produit financier suggéré",
    "statistics": "Statistiques"
  },
  "user": {
    "id": "ID",
    "stringId": "ID chaîne",
    "availableCurrencies": "Devises disponibles",
    "suitabilityScore": "Score d'adéquation",
    "latestNsfs": "Dernier NSF",
    "state": "État",
    "title": "Titre",
    "firstName": "Prénom",
    "middleName": "Deuxième prénom",
    "lastName": "Nom de famille",
    "primaryEmail": "Courriel principal",
    "dateOfBirth": "Date de naissance",
    "dateOfDeath": "Date de décès",
    "phone": "Téléphone",
    "gender": "Genre",
    "citizenships": "Citoyennetés",
    "foreignTaxExists": "Impôt étranger existant",
    "employmentStatus": "Situation d'emploi",
    "jobTitle": "Titre du poste",
    "companyType": "Type d'entreprise",
    "studentAreaOfStudy": "Domaine d'études",
    "annualIncomeCents": "Revenu annuel (cents)",
    "annualIncomeStr": "Revenu annuel (chaîne)",
    "financialLiquidAssetsCents": "Actifs liquides (cents)",
    "financialFixedAssetsCents": "Actifs immobilisés (cents)",
    "totalDebtCents": "Dette totale (cents)",
    "annualDebtPaymentsCents": "Paiements annuels de la dette (cents)",
    "debtAssociated": "Dette associée",
    "isOfficerOfPublicCompany": "Dirigeant d'entreprise publique",
    "isOwnerOfPublicCompany": "Propriétaire d'entreprise publique",
    "isMemberOfIiroc": "Membre de l'OCRCVI",
    "politicallyExposedForeignPerson": "Personne politiquement exposée (étranger)",
    "politicallyExposedDomesticPerson": "Personne politiquement exposée (national)",
    "closeAssociateOfPEP": "Proche d'une PPE",
    "pepReason": "Raison PPE",
    "investmentKnowledge": "Connaissances en placement",
    "investmentKnowledgeLabel": "Libellé des connaissances en placement",
    "investmentKnowledgeDescription": "Description des connaissances en placement",
    "isAccreditedInvestor": "Investisseur accrédité",
    "riskQuestion1": "Question de risque 1",
    "riskQuestion1Label": "Libellé question de risque 1",
    "riskQuestion2": "Question de risque 2",
    "riskQuestion2Label": "Libellé question de risque 2",
    "retirementAge": "Âge de la retraite",
    "powerOfAttorneyGranted": "Procuration accordée",
    "language": "Langue",
    "timezone": "Fuseau horaire",
    "incompleteFields": "Champs incomplets",
    "createdAt": "Créé le",
    "updatedAt": "Mis à jour le",
    "completedAt": "Complété le",
    "headOfInternationalOrganization": "Chef d'organisation internationale",
    "maritalStatus": "État civil",
    "spouseTitle": "Titre du conjoint",
    "numberOfDependents": "Nombre de personnes à charge",
    "spouseFirstName": "Prénom du conjoint",
    "spouseMiddleName": "Deuxième prénom du conjoint",
    "spouseLastName": "Nom du conjoint",
    "spouseEmail": "Courriel du conjoint",
    "spouseEmployerName": "Employeur du conjoint",
    "spouseEmployerCompanyPhone": "Téléphone employeur du conjoint",
    "spouseEmploymentStatus": "Situation d'emploi du conjoint",
    "spouseEmploymentType": "Type d'emploi du conjoint",
    "spouseCompanyType": "Type d'entreprise du conjoint",
    "spouseJobTitle": "Titre du poste du conjoint",
    "spouseAnnualIncomeCents": "Revenu annuel du conjoint (cents)",
    "spouseAnnualIncomeStr": "Revenu annuel du conjoint (chaîne)",
    "spouseAreaOfStudy": "Domaine d'études du conjoint",
    "spouseDateOfBirth": "Date de naissance du conjoint",
    "spouseTaxId": "NIF du conjoint",
    "spouseTaxIdDisclosed": "NIF du conjoint divulgué",
    "spouseTaxIdType": "Type de NIF du conjoint",
    "lastUpdatedBy": "Dernière mise à jour par",
    "iDCheckCompleted": "Vérification d'identité terminée",
    "iDCheckRetrigger": "Relancer la vérification d'identité",
    "insiderSymbols": "Symboles initiés",
    "ssSymbols": "Symboles SS",
    "complianceIssueSource": "Source du problème de conformité",
    "complianceState": "État de conformité",
    "affiliateOnly": "Affilié uniquement",
    "lastSuitabilityReviewAt": "Dernière révision d'adéquation le",
    "iDVerified": "Identité vérifiée",
    "hasCheckedPolicyAndCondition": "A accepté les politiques et conditions",
    "bulkAccountOpening": "Ouverture de comptes en masse",
    "suitabilityReviewOverdue": "Révision d'adéquation en retard",
    "sinExists": "NAS existant",
    "inProvinceSince": "Dans la province depuis",
    "countryOfTaxResidence": "Pays de résidence fiscale",
    "employerName": "Nom de l'employeur",
    "employerCompanyPhone": "Téléphone de l'entreprise",
    "employmentSituation": "Situation d'emploi",
    "employmentSituationOtherDescription": "Autre description de la situation",
    "sourceOfWealth": "Source de la richesse",
    "sourceOfWealthOtherDescription": "Autre description de la source",
    "sourceOfFunds": "Source des fonds",
    "sourceOfFundsOtherDescription": "Autre description des fonds",
    "uniqueCircumstances": "Circonstances particulières",
    "preferredMethodOfCommunication": "Méthode de communication préférée",
    "preferredMethodOfCommunicationOtherDescription": "Autre méthode de communication",
    "readyToSignAgreement": "Prêt à signer l'entente",
    "type": "Type",
    "entityName": "Nom de l'entité",
    "typeOfTrust": "Type de fiducie",
    "identificationType": "Type d'identification",
    "registrationNumber": "Numéro d'enregistrement",
    "charityRegistrationNumber": "Numéro d'organisme de bienfaisance",
    "establishedDate": "Date de constitution",
    "countryOfRegistration": "Pays d'enregistrement",
    "businessPhone": "Téléphone professionnel",
    "yearEnd": "Fin d'exercice",
    "regulatorName": "Nom du régulateur",
    "firmNumber": "Numéro de la firme",
    "issuerName": "Nom de l'émetteur",
    "issuerTicker": "Symbole de l'émetteur",
    "issuerExchange": "Bourse de l'émetteur",
    "parentCompanyName": "Nom de la société mère",
    "isEntityRegulated": "Entité réglementée",
    "isReportingIssuer": "Émetteur assujetti",
    "isRegisteredWithCRA": "Enregistré auprès de l'ARC",
    "receivesDonationsFromPublic": "Reçoit des dons du public",
    "isAFinancialEntity": "Entité financière",
    "isAffiliateOfFinancialEntity": "Filiale d'entité financière",
    "instructionsFromFinancialEntity": "Instructions d'une entité financière",
    "isPublicBody": "Organisme public",
    "isLargeCorporation": "Grande entreprise",
    "hasGuarantor": "A un garant",
    "tradingAuthorityOverAccountGranted": "Autorité de négociation accordée",
    "discretionOverAccountGranted": "Discrétion sur le compte accordée",
    "advisorInterest": "Intérêt du conseiller",
    "advisorInterestDetail": "Détail de l'intérêt du conseiller",
    "investmentFirmTrade": "Opération de la firme",
    "useBorrowedMoney": "Utilisation d'argent emprunté",
    "taxNumber": "Numéro fiscal",
    "isForThirdParty": "Pour un tiers",
    "tradingAuthorityName": "Nom de l'autorité de négociation",
    "investmentFirmTradeName": "Nom de l'opération de la firme",
    "otherPersonGuaranteeNames": "Noms des autres garants",
    "thirdPartyName": "Nom du tiers",
    "isNonProfit": "Organisme sans but lucratif",
    "positionAtEntity": "Poste au sein de l'entité",
    "isVulnerablePerson": "Personne vulnérable",
    "isOwnerOfEntity": "Propriétaire de l'entité",
    "fatcaStatus": "Statut FATCA",
    "fatcaStatusOtherDescription": "Autre description du statut FATCA",
    "taxId": "NIF",
    "taxIdDisclosed": "NIF divulgué",
    "taxIdType": "Type de NIF",
    "nextSuitabilityReviewAt": "Prochaine révision d'adéquation le",
    "riskScore": "Score de risque",
    "netWorthCents": "Valeur nette (cents)",
    "totalAssetsCents": "Actifs totaux (cents)",
    "discretionOverAccountGrantedReason": "Raison de la discrétion accordée",
    "convertedFromAffiliateInvitation": "Converti depuis une invitation d'affilié",
    "physicalAddress": "Adresse physique",
    "organization": "Organisation",
    "fraudRisk": "Risque de fraude",
    "feeTier": "Palier de frais",
    "applicableFeeTier": "Palier de frais applicable",
    "billingSchedule": "Calendrier de facturation",
    "applicableBillingSchedule": "Calendrier de facturation applicable",
    "latestIdVerification": "Dernière vérification d'identité",
    "trustedContactPerson": "Personne de confiance",
    "suggestedFinancialProduct": "Produit financier suggéré",
    "statistics": "Statistiques",
    "alternateAddress": "Adresse physique secondaire",
    "mailingAddress": "Adresse postale",
    "employerCompanyAddress": "Adresse de l'employeur",
    "spouseAddress": "Adresse du conjoint",
    "spouseEmployerCompanyAddress": "Adresse de l'employeur du conjoint"
  },
  "accountGroup": {
    "id": "ID",
    "translatedName": "Nom traduit",
    "type": "Type",
    "state": "État",
    "totalAccounts": "Total des comptes",
    "lastUpdatedBy": "Dernière mise à jour par",
    "createdAt": "Créé le",
    "user": "Utilisateur",
    "householdClientGroup": "ClientGroup",
    "organization": "Organisation",
    "statistics": "Statistiques"
  },
  "clientGroup": {
    "stringId": "ID chaîne",
    "type": "Type",
    "availableCurrencies": "Devises disponibles",
    "id": "ID",
    "name": "Nom",
    "state": "État",
    "completedAt": "Complété le",
    "incompleteFields": "Champs incomplets",
    "primaryEmail": "Courriel principal",
    "phone": "Téléphone",
    "businessIsMemberOfIiroc": "Entreprise membre de l'OCRCVI",
    "establishedDate": "Date de constitution",
    "corporationCountry": "Pays de la société",
    "incorporationNumber": "Numéro d'incorporation",
    "businessType": "Type d'entreprise",
    "taxNumber": "Numéro fiscal",
    "accountNumber": "Numéro de compte",
    "taxNumberDisclosed": "Numéro fiscal divulgué",
    "createdAt": "Créé le",
    "primaryUser": "Utilisateur principal",
    "organization": "Organisation",
    "feeTier": "Palier de frais",
    "applicableFeeTier": "Palier de frais applicable",
    "billingSchedule": "Calendrier de facturation",
    "applicableBillingSchedule": "Calendrier de facturation applicable",
    "physicalAddress": "Adresse physique",
    "statistics": "Statistiques"
  },
  "organization": {
    "id": "ID",
    "embeddedExperienceLogoUrl": "URL du logo d'expérience intégrée",
    "defaultBillingSchedule": "Calendrier de facturation par défaut",
    "defaultFeeTier": "Palier de frais par défaut",
    "translatedName": "Nom traduit",
    "subdomain": "Sous-domaine",
    "parent": "Parent",
    "minInvestAmountCents": "Montant minimum d'investissement (cents)",
    "minInitialDepositCents": "Dépôt initial minimum (cents)",
    "translatedTermsAndConditionsUrl": "URL des conditions générales traduites",
    "translatedSupportUrl": "URL du support traduite",
    "translatedHelpCentreUrl": "URL du centre d'aide traduite",
    "cashOnHoldToTradeDays": "Jours de trésorerie bloquée avant négociation",
    "cashOnHoldToWithdrawDays": "Jours de trésorerie bloquée avant retrait",
    "cancelTransferCutoffDays": "Jours limite d'annulation de transfert",
    "defaultTradingProcess": "Processus de négociation par défaut",
    "bulkTradingProcess": "Processus de négociation en masse",
    "minDepositCents": "Dépôt minimum (cents)",
    "productShelfCurrencies": "Devises des produits",
    "customUrl": "URL personnalisée",
    "faviconLink": "Lien favicon",
    "browserTabTitle": "Titre de l'onglet",
    "localization": "Localisation",
    "applicableLocalization": "Localisation applicable",
    "profileReviewTimeInMonths": "Délai de révision du profil (mois)",
    "repCode": "Code du représentant",
    "entityName": "Nom de l'entité",
    "minRecurringDepositCents": "Dépôt récurrent minimum (cents)",
    "defaultAuthenticationConnection": "Connexion d'authentification par défaut",
    "multiFactorAuthenticationOptions": "Options d'authentification multifacteur",
    "baseCurrency": "Devise de base",
    "jurisdictions": "Juridictions activées",
    "applicableJurisdictions": "Juridictions applicables"
  },
  "custodianConnection": {
    "id": "ID",
    "name": "Nom",
    "moneyAccount": "Compte espèces",
    "inventoryAccount": "Compte d'inventaire",
    "type": "Type",
    "repCode": "Code du représentant",
    "notificationEmails": "Courriels de notification",
    "default": "Par défaut",
    "enableCustodianActivityImport": "Activer l'import des activités dépositaire",
    "allowTransactionCreation": "Autoriser la création de transactions",
    "enableCustodianSnapshotImport": "Activer l'import des instantanés dépositaire",
    "enableFetchCustodianStatistics": "Activer la récupération des statistiques dépositaire",
    "enableFetchCustodianUpcomingTransactions": "Activer la récupération des transactions à venir",
    "enableFetchCustodianSuitability": "Activer la récupération de l'adéquation dépositaire",
    "enableFetchCustodianSnapshotHistory": "Activer l'historique des instantanés dépositaire",
    "enableFetchCustodianTransactions": "Activer la récupération des transactions dépositaire",
    "enableFetchCustodianProjectedIncome": "Activer la récupération du revenu projeté",
    "enableFetchCustodianCustomFields": "Activer la récupération des champs personnalisés",
    "enableCustodianOrganizationImport": "Activer l'import organisation dépositaire",
    "enableCustodianOrganizationUserImport": "Activer l'import utilisateurs organisation",
    "enableAutoReconcileActivities": "Activer la réconciliation automatique des activités",
    "enableAutoReconcilePositions": "Activer la réconciliation automatique des positions",
    "custodianActivityImportFilePaths": "Chemins d'import des activités",
    "custodianSnapshotImportFilePaths": "Chemins d'import des instantanés",
    "custodianUsersImportFilePath": "Chemin d'import des utilisateurs dépositaire",
    "customerName": "Nom du client",
    "enablleTransferSubmission": "Activer la soumission des transferts",
    "enableCustodianUserImport": "Activer l'import des utilisateurs dépositaire",
    "enableCustodianAccountImport": "Activer l'import des comptes dépositaire",
    "transferSubmissionType": "Type de soumission des transferts",
    "accountOpeningSubmissionType": "Type de soumission d'ouverture de compte",
    "enableAccountOpeningSubmission": "Activer la soumission d'ouverture de compte",
    "disabledFlagTypes": "Types de drapeaux désactivés",
    "reconciliationType": "Type de réconciliation",
    "accountTypeSettings": "Paramètres du type de compte",
    "baseCurrency": "Devise de base",
    "allowFractionalTrading": "Autoriser la négociation fractionnaire",
    "fetchLivePrices": "Récupérer les cours en direct",
    "enableFetchCustodianStatements": "Activer la récupération des relevés dépositaire",
    "enableCreateCustodianDepositTransfers": "Activer la création des transferts de dépôt",
    "enableCancelCustodianDepositTransfer": "Activer l'annulation des transferts de dépôt",
    "enableFetchCustodianNotifications": "Activer la récupération des notifications dépositaire",
    "enableChallengedCustodianDepositTransfer": "Activer les transferts de dépôt contestés",
    "enableCustodianCredentialsManager": "Activer le gestionnaire d'identifiants dépositaire",
    "enableSaveInternalRecordsOfCustodianDepositTransfers": "Activer l'enregistrement interne des transferts",
    "allowCashAsDepositTarget": "Autoriser les espèces comme cible de dépôt",
    "bulkTradeAllowedExchanges": "Bourses autorisées pour la négociation en masse",
    "disableCorpInventoryAccount": "Désactiver le compte d'inventaire société"
  },
  "enabledJurisdictions": {
    "all": "Toutes",
    "only": "Uniquement"
  },
  "repCode": {
    "code": "Code",
    "id": "ID",
    "name": "Nom",
    "archived": "Archivé",
    "state": "État"
  },
  "transactionTotal": {
    "totalCount": "Nombre total",
    "totalCents": "Total (cents)"
  },
  "fraudRisk": {
    "id": "ID",
    "score": "Score",
    "lastUpdatedBy": "Dernière mise à jour par",
    "notes": "Notes"
  },
  "alternatePhysicalAddress": {
    "line1": "Ligne 1",
    "line2": "Ligne 2",
    "city": "Ville",
    "jurisdiction": "Juridiction",
    "country": "Pays",
    "postal": "Code postal"
  },
  "alternateAddress": {
    "city": "Ville",
    "country": "Pays",
    "jurisdiction": "Juridiction",
    "postal": "Code postal",
    "line1": "Ligne 1",
    "line2": "Ligne 2"
  },
  "trustedContactPerson": {
    "name": "Nom",
    "relation": "Relation",
    "email": "Courriel",
    "phone": "Téléphone",
    "physicalAddress": "Adresse physique"
  },
  "idVerification": {
    "id": "ID",
    "methodOfIDVerification": "Méthode de vérification d'identité",
    "verifiedDate": "Date de vérification",
    "userName": "Nom d'utilisateur",
    "documentType": "Type de document",
    "documentID": "ID du document",
    "documentIssuingJurisdication": "Juridiction d'émission du document",
    "documentExpiryDate": "Date d'expiration du document",
    "secondaryDocumentType": "Type de document secondaire",
    "secondaryDocumentUserName": "Nom sur le document secondaire",
    "secondaryDocumentID": "ID du document secondaire",
    "secondaryDocumentIssuingJurisdication": "Juridiction d'émission du document secondaire",
    "secondaryDocumentExpiryDate": "Date d'expiration du document secondaire",
    "secondaryDocumentDateOfBirth": "Date de naissance sur le document secondaire",
    "secondaryDocumentVerifiedDate": "Date de vérification du document secondaire",
    "state": "État",
    "creditFileSource": "Source du dossier de crédit",
    "address": "Adresse"
  },
  "physicalAddress": {
    "unitNumber": "Numéro d'unité",
    "houseNumber": "Numéro civique",
    "streetName": "Nom de rue",
    "neighborhood": "Quartier",
    "city": "Ville",
    "jurisdiction": "Juridiction",
    "country": "Pays",
    "postal": "Code postal"
  },
  "feeTier": {
    "id": "ID",
    "name": "Nom",
    "default": "Par défaut",
    "blendedGrid": "Grille mixte",
    "gridScopeType": "Type de portée de la grille",
    "flatAnnualFeeBps": "Frais annuels fixes (bps)",
    "discountPercentage": "Pourcentage de remise",
    "chargeForCashOnHold": "Frais pour trésorerie bloquée",
    "chargeForCash": "Frais pour espèces",
    "state": "État",
    "requestId": "ID de demande",
    "type": "Type",
    "createdAt": "Créé le",
    "updatedAt": "Mis à jour le",
    "extensionKey": "Clé d'extension",
    "resourceKey": "Clé de ressource",
    "extensionVersion": "Version d'extension"
  },
  "billingSchedule": {
    "id": "ID",
    "default": "Par défaut",
    "frequency": "Fréquence",
    "nextBillingDate": "Prochaine date de facturation",
    "nextCalculationDate": "Prochaine date de calcul",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "state": "État",
    "requestId": "ID de demande",
    "createdAt": "Créé le",
    "updatedAt": "Mis à jour le",
    "extensionKey": "Clé d'extension",
    "resourceKey": "Clé de ressource",
    "extensionVersion": "Version d'extension"
  },
  "financialProduct": {
    "id": "ID",
    "stringId": "ID chaîne",
    "priceHistoryUrl": "URL de l'historique des prix",
    "name": "Nom",
    "translatedName": "Nom traduit",
    "state": "État",
    "suggestedMinScore": "Score minimum suggéré",
    "suggestedMaxScore": "Score maximum suggéré",
    "lowThresholdScore": "Score de seuil bas",
    "tradeable": "Négociable",
    "suggestable": "Suggérable",
    "autoUpdatePrices": "Mise à jour automatique des prix",
    "assignable": "Attribuable",
    "ticker": "Symbole",
    "exchange": "Bourse",
    "currency": "Devise",
    "originalCurrency": "Devise d'origine",
    "forecastedRateOfReturn": "Taux de rendement prévu",
    "forecastedStandardDeviation": "Écart-type prévu",
    "currentPriceCents": "Prix actuel (cents)",
    "originalCurrentPriceCents": "Prix actuel d'origine (cents)",
    "portfolioDescription": "Description du portefeuille",
    "translatedPortfolioDescription": "Description du portefeuille traduite",
    "portfolioDisclaimer": "Avertissement du portefeuille",
    "translatedPortfolioDisclaimer": "Avertissement du portefeuille traduit",
    "investmentObjective": "Objectif de placement",
    "translatedInvestmentObjective": "Objectif de placement traduit",
    "translatedLiquidity": "Liquidité traduite",
    "updatedAt": "Mis à jour le",
    "riskReturnLevel": "Niveau risque-rendement",
    "isCash": "Espèces",
    "substituteFinancialProduct": "Produit financier de substitution",
    "isPartial": "Partiel",
    "waivedFeePercentage": "Pourcentage de frais renoncés",
    "taxRank": "Rang fiscal",
    "settlementDays": "Jours de règlement",
    "volatile": "Volatil",
    "translatedUrl": "URL traduite",
    "cusip": "CUSIP",
    "isin": "ISIN",
    "ric": "RIC",
    "exchangeMic": "MIC de la bourse",
    "foreignExchangeRate": "Taux de change",
    "riskProfileName": "Nom du profil de risque",
    "riskProfileDescription": "Description du profil de risque",
    "translatedThemeName": "Nom du thème traduit",
    "strategy": "Stratégie",
    "type": "Type",
    "zeroPercentCash": "Zéro pour cent espèces",
    "multiplier": "Multiplicateur",
    "cloneOf": "Clone de",
    "fundSeries": "Série de fonds",
    "theme": "Thème",
    "primaryAssetClass": "Classe d'actifs principale",
    "secondaryAssetClass": "Classe d'actifs secondaire",
    "tertiaryAssetClass": "Classe d'actifs tertiaire",
    "schedule": "Calendrier",
    "portfolioTemplate": "Modèle de portefeuille"
  },
  "theme": {
    "id": "ID",
    "name": "Nom",
    "translatedName": "Nom traduit",
    "description": "Description",
    "translatedDescription": "Description traduite",
    "translatedShortDescription": "Description courte traduite",
    "key": "Clé",
    "core": "Principal",
    "iconKey": "Clé d'icône",
    "state": "État"
  },
  "assetClass": {
    "id": "ID",
    "stringId": "ID chaîne",
    "key": "Clé",
    "name": "Nom",
    "description": "Description",
    "translatedName": "Nom traduit",
    "translatedDescription": "Description traduite",
    "state": "État",
    "includeCash": "Inclure les espèces",
    "riskLevel": "Niveau de risque"
  },
  "schedule": {
    "id": "ID",
    "name": "Nom",
    "dates": "Dates",
    "nextDate": "Prochaine date",
    "associatedFinancialProductsCount": "Nombre de produits financiers associés"
  },
  "portfolioTemplate": {
    "id": "ID",
    "name": "Nom",
    "translatedName": "Nom traduit",
    "translatedTemplateDescription": "Description du modèle traduite",
    "state": "État",
    "createdAt": "Créé le",
    "updatedAt": "Mis à jour le"
  },
  "statistics": {
    "stringId": "ID chaîne",
    "currency": "Devise",
    "objectType": "Type d'objet",
    "forUserId": "Pour l'ID utilisateur",
    "marketValueCents": "Valeur de marché (cents)",
    "netContributionCents": "Contribution nette (cents)",
    "newContributionCents": "Nouvelle contribution (cents)",
    "simpleReturnAmount": "Montant du rendement simple",
    "simpleReturnPercent": "Pourcentage du rendement simple",
    "timeWeightedReturn": "Rendement pondéré par le temps",
    "moneyWeightedReturn": "Rendement pondéré par les flux",
    "netContributionCentsInFiscalYear": "Contribution nette dans l'exercice (cents)",
    "id": "ID",
    "capitalGainsAndLossesInFiscalYear": "Gains et pertes en capital dans l'exercice",
    "depositContributionCents": "Contribution des dépôts (cents)",
    "withdrawContributionCents": "Contribution des retraits (cents)",
    "lastUpdatedAt": "Dernière mise à jour le",
    "eodMarketValueCents": "Valeur de marché en clôture (cents)",
    "moneyAvailableCents": "Espèces disponibles (cents)",
    "expectedMoneyAvailableCents": "Espèces attendues (cents)",
    "pendingContributionCents": "Contribution en attente (cents)",
    "pendingCashCents": "Espèces en attente (cents)",
    "pendingWithdrawCents": "Retrait en attente (cents)",
    "availableFundsToWithdrawCents": "Fonds disponibles pour retrait (cents)",
    "cashOnHoldToTradeCents": "Trésorerie bloquée pour négociation (cents)",
    "cashOnHoldToWithdrawCents": "Trésorerie bloquée pour retrait (cents)",
    "totalBookCostCents": "Coût comptable total (cents)",
    "totalPercentage": "Pourcentage total",
    "taxLossHarvestCreditInFiscalYear": "Crédit de récupération fiscale dans l'exercice",
    "unrealizedGainsAndLoss": "Gains et pertes non réalisés"
  },
  "taxLossHarvestCredit": {
    "id": "ID",
    "account": "Compte",
    "year": "Année",
    "creditsCents": "Crédits (cents)"
  },
  "unrealizedGainsAndLoss": {
    "unrealizedGainsAndLossCents": "Gains et pertes non réalisés (cents)",
    "unrealizedGainsAndLossCentsPercentage": "Pourcentage des gains et pertes non réalisés"
  },
  "custodian": {
    "id": "ID",
    "name": "Nom",
    "moneyAccount": "Compte espèces",
    "inventoryAccount": "Compte d'inventaire",
    "type": "Type",
    "repCode": "Code du représentant",
    "notificationEmails": "Courriels de notification",
    "customerName": "Nom du client"
  },
  "scheduledIncomeFundTransfer": {
    "id": "ID",
    "frequency": "Fréquence",
    "scheduledDate": "Date prévue",
    "annualAmountCents": "Montant annuel (cents)",
    "amountPayableType": "Type de montant payable",
    "dateOfBirth": "Date de naissance",
    "minimumAnnualAmountCents": "Montant annuel minimum (cents)",
    "state": "État",
    "taxOption": "Option fiscale",
    "specialTaxRate": "Taux d'imposition spécial",
    "currency": "Devise",
    "subAccount": "Sous-compte",
    "bankAccount": "Compte bancaire"
  },
  "bankAccount": {
    "id": "ID",
    "stringId": "ID chaîne",
    "name": "Nom",
    "institutionNumber": "Numéro d'institution",
    "routingNumber": "Numéro de routage",
    "transitNumber": "Numéro de transit",
    "processorToken": "Jeton du processeur",
    "bankAccountType": "Type",
    "bankAccountNumber": "Numéro",
    "transitNumberDisclosed": "Numéro de transit divulgué",
    "bankAccountNumberDisclosed": "Numéro divulgué",
    "state": "État",
    "createdAt": "Créé le",
    "updatedAt": "Mis à jour le",
    "source": "Source",
    "EftEligibleRatio": "Ratio d'éligibilité au virement",
    "failReason": "Raison de l'échec",
    "fieldMatchRate": "Taux de correspondance des champs",
    "bankAccountHolderName": "Nom du titulaire",
    "currency": "Devise",
    "downloadUrls": "URLs de téléchargement",
    "user": "Utilisateur",
    "bankAccountTransitPhysicalAddress": "Adresse physique de transit du compte bancaire"
  },
  "bankAccountTransitPhysicalAddress": {
    "houseNumber": "Numéro civique",
    "unitNumber": "Numéro d'unité",
    "streetName": "Nom de rue",
    "city": "Ville",
    "jurisdiction": "Juridiction",
    "country": "Pays",
    "postal": "Code postal"
  }
}
